import { render, staticRenderFns } from "./ChangeDataLanguages.vue?vue&type=template&id=498b9085&"
import script from "./ChangeDataLanguages.vue?vue&type=script&lang=js&"
export * from "./ChangeDataLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports